var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cheers",
    clipPath: "url(#clip0_1827_4833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99969 4.375L12.4997 3.75C12.4997 3.75 14.5684 6.98047 15.5388 10.6023C15.6251 10.9199 15.6478 11.2514 15.6057 11.5777C15.5636 11.9041 15.4575 12.2189 15.2935 12.5042C15.1295 12.7895 14.9107 13.0396 14.6498 13.2401C14.3889 13.4406 14.091 13.5877 13.7731 13.6728C13.4553 13.758 13.1237 13.7795 12.7975 13.7363C12.4713 13.693 12.1568 13.5858 11.8722 13.4207C11.5875 13.2556 11.3382 13.036 11.1386 12.7743C10.939 12.5127 10.7931 12.2143 10.7091 11.8961C9.73875 8.27422 9.99969 4.375 9.99969 4.375Z",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.7715 13.6641L14.8934 17.8492",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.875 17.318L13.125 18.3227",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.99961 2.5L7.49961 1.875C7.49961 1.875 5.43086 5.10547 4.46055 8.72734C4.37425 9.04489 4.35149 9.37636 4.39358 9.70272C4.43566 10.0291 4.54177 10.3439 4.7058 10.6292C4.86984 10.9145 5.08858 11.1646 5.34948 11.3651C5.61038 11.5656 5.90831 11.7127 6.22617 11.7978C6.54403 11.883 6.87557 11.9045 7.20178 11.8613C7.528 11.818 7.84246 11.7108 8.12713 11.5457C8.4118 11.3806 8.66108 11.161 8.86067 10.8993C9.06027 10.6377 9.20625 10.3393 9.29024 10.0211C10.1785 6.39063 9.99961 2.5 9.99961 2.5Z",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.2293 11.7891L5.10742 15.9742",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.125 15.443L6.875 16.4477",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.0381 7.64687L14.0576 6.64062",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9.91523 5.91642L5.87695 4.90704",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15 3.125L16.25 2.5",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M16.25 5.625H17.5",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M4.375 2.5L3.125 1.875",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M3.125 5H1.875",
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1827_4833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishIcon);
export default __webpack_public_path__ + "static/media/finishIcon.993a6d494607e387e24befd4a8d4dd9b.svg";
export { ForwardRef as ReactComponent };